import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface UserState {
  listProjects: any[];
  defaultBoard: any;
  defaultProject: any;
  profile: any;
  token: any;
  setListProjects: (u: any) => void;
  setDefaultProject: (u: any) => void;
  setDefaultBoard: (u: any) => void;
  setProfile: (u: any) => void;
  setToken: (u: any) => void;
  resetStorage: () => void;
}

export const useUser = create<UserState>()(
  persist(
    (set) => ({
      profile: null,
      listProjects: [],
      defaultProject: null,
      defaultBoard: null,
      token: '',
      setToken: (token) => {
        set({ token });
      },
      setProfile: (profile) => {
        set({ profile });
      },
      setDefaultBoard: (defaultBoard) => {
        set({ defaultBoard });
      },
      setDefaultProject: (defaultProject) => {
        set({ defaultProject });
      },
      setListProjects: (listProjects) => {
        set({ listProjects });
      },
      resetStorage: () => {
        set({
          profile: null,
          listProjects: [],
          defaultProject: null,
          defaultBoard: null,
        });
      },
    }),
    {
      name: "user-profile-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
